import { Component, OnInit, Input } from '@angular/core';
import { ModalController, AlertController, ToastController } from '@ionic/angular';
import { TransactionsService } from 'src/app/api/transactions.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppSettings } from 'src/app/app-settings';

@Component({
  selector: 'app-new-preview',
  templateUrl: './new-preview.page.html',
  styleUrls: ['./new-preview.page.scss'],
})
export class NewPreviewPage implements OnInit {

  @Input() emailInfos;

  public previewForm: FormGroup;

  public selfCopy: boolean;

  public recipients: string[] = ["NEL"];

  isWeb = AppSettings.IS_WEB;

  constructor(
    private modalCtrl: ModalController,
    private transactionsService: TransactionsService,
    private formBuilder: FormBuilder,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
  ) { }

  ngOnInit() {
    this.previewForm = this.formBuilder.group({
      'recipient': [this.emailInfos['recipient'], Validators.compose([
        Validators.required
      ])],
      'subject': [this.emailInfos['subject'], Validators.compose([
        Validators.required
      ])],
      'message': [this.emailInfos['message'], Validators.compose([
        Validators.required
      ])]
    })

    this.selfCopy = this.emailInfos['self_copy'];
  }

  ionViewWillEnter() {
  }

  isMailSendCalled: boolean = false;

  async sendMail() {
    let t = this;

    const toast = await this.toastCtrl.create({
      message: 'Your offer will be posted soon.',
      duration: 3000,
      showCloseButton: true,
      position: 'bottom',
      color: 'light',
    })

    this.isMailSendCalled = !this.isMailSendCalled;
    this.transactionsService.mail({
      'email_id': this.emailInfos['email_id'],
      'recipient': this.previewForm.value.recipient,
      'subject': this.previewForm.value.subject,
      'message': this.previewForm.value.message,
      'self_copy': this.selfCopy
    }).then(async () => {
      toast.present();
      this.isMailSendCalled = !this.isMailSendCalled;
      await t.modalCtrl.dismiss(true);
    }).catch(async () => {
      toast.dismiss(false);
    });

  }

  async closePreviewOffer() {
    let alert = await this.alertCtrl.create({
      header: 'Are you sure you want to leave?',
      message: 'Queued offers will be removed.',
      buttons: [
        {
          text: 'No, take me back',
          role: 'cancel',
          cssClass: 'cancelAlert',
        },
        {
          text: "Yes, I'm sure",
          cssClass: 'validateClose',
          handler: async () => {
            this.transactionsService.deleteMail({
              'email_id': this.emailInfos['email_id']
            }).catch(async () => {
              alert.dismiss(false)
            });
            await this.modalCtrl.dismiss(false);
          }
        }
      ]
    })

    await alert.present();
  }

}
